
import { platform, Bridge } from '@/common/bridge';
import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import BubbleIcon from './icons/BubbleIcon.vue';
import { OpenHelpEntry, OpenHelpEntryType } from '@/common/entryLog';
import { GA_EVENT_NAME_ENUM } from '@/common/gaHelper';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';

const chatModule = namespace('chat');
const userModule = namespace('user');

@Component({ components: { BubbleIcon }, directives: { trackClick } })
export default class FloatButton extends Vue {
  @chatModule.State('hasNewMessage') hasNewMessage!: boolean;
  @userModule.Mutation('updatePageSource') updatePageSource!: (pageSource: OpenHelpEntryType) => void;
  isPC = platform === 'web';

  readonly BTN_EVTS = BTN_EVTS;

  get containerClass () {
    return this.hasNewMessage ? 'container__new-msg' : 'container';
  }

  openHelp () {
    this.updatePageSource(OpenHelpEntry.PLEASED_FLOATING_BUTTON);
    this.$gtag.event(GA_EVENT_NAME_ENUM.OPEN_CHATBOT);
    Bridge.maximize();
  }
}
